import styled from 'styled-components';
import { Button } from '@/components/UI/Button/Button';

export const Box = styled.div`
  position: fixed;
  bottom: ${({ theme }) =>
    theme.isWebView ? `${+theme.insetsBottom + 15}px` : '15px'};
  right: 15px;
  left: 15px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  z-index: 9;
`;

export const FloatingButton = styled(Button)`
  height: 54px;
`;

export const ButtonIconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
`;
